import { render, staticRenderFns } from "./ProductionOrderCard.vue?vue&type=template&id=17acc53f&"
import script from "./ProductionOrderCard.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports